import { render, staticRenderFns } from "./QRPreRegister.vue?vue&type=template&id=c42c51c4&scoped=true"
import script from "./QRPreRegister.vue?vue&type=script&lang=js"
export * from "./QRPreRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42c51c4",
  null
  
)

export default component.exports